import React, {Component} from 'react';
import {Link} from 'react-router';
import {RightArrow} from '~/shared/legacy_presentational-components/Elements/Elements';
import formStyles from '~/shared/legacy_presentational-components/Form/Form.module.scss';
import styles from '../Signup.module.scss';

class Complete extends Component {
    render() {
        return (
            <div className={styles.main_kyc}>
                <div>
                    <div className={styles.wrapper}>
                        <p className={styles.baseP}>
                            The KYC procedure is still in progress for you. Once done you will be able to access all our
                            services. Thanks for waiting and see you soon!
                        </p>
                        <div className={styles.status_wait} />
                        <p className={styles.baseP}>
                            We try to be the fastest in the market. Normally, the whole process takes about 6 minutes.
                        </p>
                    </div>
                    <Link className={formStyles.bottomButton} to='/assets'>
                        Back to my accounts <RightArrow />
                    </Link>
                </div>
            </div>
        );
    }
}

export default Complete;
